<template>
    <section class="timeline">
        <div class="timeline-bloc">
            <div class="timeline-title">{{ $t("orders.timeline.title") }}</div>
            <div class="timeline-steps">
                <span class="roundedIcon active"> <i class="fas fa-list-alt fa-2x"></i></span>
                <span class="roundedIcon"> <i class="fas fa-file-invoice-dollar fa-2x"></i></span>
                <span class="roundedIcon"> <i class="fas fa-check fa-2x"></i></span>
                <span class="roundedIcon"> <i class="fas fa-shipping-fast fa-2x"></i></span>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Timeline"
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
.timeline {
    &-bloc {
        @extend %primary-text;
        &:after {
            content: "";
            display: block;
            clear: both;
        }
    }
    &-title {
        text-transform: uppercase;
        font-size: 25px;
        font-family: Oswald;
        float: left;
    }
    &-steps {
        float: left;
        top: -4px;
        margin-left: 10px;
        position: relative;
        .roundedIcon {
            background-color: #d4d4d4;
            font-size: 10px;
            display: inline-block;
            margin: 0 5px;
            &.active {
                background-color: $color4;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Timeline.vue?4be9b3a0